module.exports = __webpack_public_path__ + "img/alpha-feedback-o.7b979a31.svg";